/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
export { DataPersistence, fetch, navigation, optimisticUpdate, pessimisticUpdate } from './src/data-persistence';
export { NxModule } from './src/nx.module';
